/**
 * Centralized URL constants for the application
 * Using this file makes it easier to change URLs across the app
 */

// Base URLs for different environments
export const BASE_URLS = {
  ASSETS: 'https://qa-assets.yucollect.in/assets',
};

// Asset paths
export const ASSET_PATHS = {
  ALLOCATOR_LOGO: '/allocator/logo',
  VENDOR_LOGO: '/vendor/logo',
};

/**
 * Utility function to get asset URLs
 * @param path - Path after the base asset URL
 * @param filename - Filename for the asset
 * @returns Full URL to the asset
 */
export const getAssetUrl = (path: string, filename: string): string => {
  return `${BASE_URLS.ASSETS}${path}/${filename}`;
};

/**
 * Gets the URL for an allocator logo
 * @param logoFilename - Filename of the allocator logo
 * @returns Full URL to the allocator logo
 */
export const getAllocatorLogoUrl = (logoFilename: string): string => {
  return getAssetUrl(ASSET_PATHS.ALLOCATOR_LOGO, logoFilename);
};

export const getVendorLogoUrl = (logoFilename: string): string => {
  return getAssetUrl(ASSET_PATHS.VENDOR_LOGO, logoFilename);
};
